import { Icon } from "@iconify/react";

export default function Banner() {
  const now = new Date();

  const start =
    process.env.REACT_APP_ENV === "development"
      ? new Date("2025-05-09T00:00:00")
      : new Date("2025-05-11T11:00:00");
  const end =
    process.env.REACT_APP_ENV === "development"
      ? new Date("2025-05-09T18:05:59")
      : new Date("2025-05-14T23:59:59");

  const isPromoPeriod = now <= end;

  // const today = new Date();
  // today.setHours(0, 0, 0, 0);

  // const promoEnd = new Date(today);
  // promoEnd.setDate(promoEnd.getDate() + 1);
  // promoEnd.setHours(17, 0, 0, 0);

  // const isPromoPeriod = new Date() < promoEnd;

  return (
    <aside className="common-banner">
      {isPromoPeriod ? (
        <h6>
          🚚 Enjoy Free Shipping with No Minimum Spend - Only from 11 May, 11:00
          AM to 14 May, 11:59 PM! 🎉
        </h6>
      ) : (
        <>
          <Icon icon="material-symbols-light:delivery-truck-bolt-outline" />
          <h6>Get Free Shipping When You Spend RM150 or More!</h6>
        </>
      )}
    </aside>
  );
}
